import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MessageCircleIcon, XIcon, PhoneIcon, MailIcon } from "lucide-react";
import { CONTACT } from "../../data/site";
import { trackEvent } from "../../utils/analytics";

/** Live chat slot — swap the panel body for the chosen chat provider's embed. */
export function ChatWidget() {
  const [open, setOpen] = useState(false);
  return <div className="relative" data-id="element-236" data-mp="13szcsi3k12wl">
      <AnimatePresence data-id="element-237" data-mp="13tr7lqpbuwlt">
        {open && <motion.div id="chat-panel" role="dialog" aria-label="Chat with NEXORA" initial={{
        opacity: 0,
        y: 8,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 8,
        scale: 0.96
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute bottom-full right-0 mb-3 w-[min(340px,calc(100vw-2rem))] origin-bottom-right rounded-2xl border border-line-strong bg-ink-2 p-5 shadow-2xl" data-id="element-238" data-mp="18qhm49lhhk54">
            <p className="font-display text-lg font-semibold" data-id="element-239" data-mp="279omi4nv63e3">Talk to the builders</p>
            <p className="mt-1 text-sm text-muted" data-id="element-240" data-mp="22cy4vcweuzqk">Live chat is coming soon. In the meantime, reach us directly:</p>
            <div className="mt-4 grid gap-2" data-id="element-241" data-mp="1xjlrjyx6mfd4">
              <a href={CONTACT.phones[0].href} className="flex min-h-[44px] items-center gap-2 rounded-xl border border-line px-3 text-sm hover:bg-white/5" data-id="element-242" data-mp="1smd87v0as5aa">
                <PhoneIcon className="h-4 w-4 text-accent-soft" data-id="element-243" data-mp="1nobqbdelyc0e" /> {CONTACT.phones[0].label}
              </a>
              <a href={`mailto:${CONTACT.email}`} className="flex min-h-[44px] items-center gap-2 rounded-xl border border-line px-3 text-sm hover:bg-white/5" data-id="element-244" data-mp="1jni2ek160x7i">
                <MailIcon className="h-4 w-4 text-accent-soft" data-id="element-245" data-mp="19o9cq3dc24qy" /> {CONTACT.email}
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
      <button type="button" aria-expanded={open} aria-controls="chat-panel" aria-label={open ? "Close chat" : "Open chat"} onClick={() => {
      setOpen(!open);
      if (!open) trackEvent("chat_open");
    }} className="grid h-14 w-14 place-items-center rounded-full border border-line-strong bg-ink-3 shadow-xl transition-[transform,background-color] duration-150 ease-out hover:bg-ink-4 active:scale-95" data-id="element-246" data-mp="341idn6rtchxl">
        {open ? <XIcon className="h-5 w-5" data-id="element-247" data-mp="xanjhyzfuspm" /> : <MessageCircleIcon className="h-5 w-5" data-id="element-248" data-mp="1l2b0np6wepep" />}
      </button>
    </div>;
}